module.exports = __webpack_public_path__ + "img/shape.6a83990f.svg";